import './barcode-reader-toggle.scss'

import { defineComponent } from 'vue';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BarcodeSubscriber } from '@skinsoft/ui';

import { TURN_OFF_BARCODE_READER_TOPIC, TURN_ON_BARCODE_READER_TOPIC } from '../../../../busTopics';

export const BarcodeReaderToggle = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBarcodeSubscriber: BarcodeSubscriber,
    },
    props: ['completelyDisabled'],
    template: require('./barcode-reader-toggle.html'),
    data() {
        return {
            barcodeIcon: faBarcode,
            enabled: false,
        }
    },
    created() {
        this.subscribeToBus(TURN_OFF_BARCODE_READER_TOPIC, () => {
            this.enabled = false;
        });
        this.subscribeToBus(TURN_ON_BARCODE_READER_TOPIC, () => {
            this.enabled = true;
        });
    },
    methods: {
        toggle() {
            this.enabled = !this.enabled;
        },
    },
})
